import {Button, Col, Row} from "antd";
import styled from "styled-components";

export const FormContainer = styled(Row)`
    width: 100%;
    padding-right: 20px;

    @media screen and (max-width: 992px) {
        padding-top: 20px;
        padding-right: 0;
    }
`;

export const FormHeader = styled(Col)`
    font-size: 20px;
    font-weight: bold;
    width: 100%;
    border-bottom: 1px solid #c6c5c5;
    padding-bottom: 5px;
`;

export const SubmitDeliveryButton = styled(Button)`
    width: 100%;
    background-color: #b2fc35;
    color: black;
    font-weight: bold;
    border: 1px solid black;
    &:hover {
        background-color: #d5fd91;
        color: black;
        border: 1px solid black;
    }
    &:focus,
    &:active {
        background-color: #d5fd91;
        color: black;
        border: 1px solid black;
    }
`;
